var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "ftr"
  }, [_c("section", {
    style: {
      background: `url(${_vm.bannerUrl}) no-repeat center 0px`,
      backgroundSize: "cover"
    }
  }, [_c("Banner", {
    attrs: {
      imageUrl: _vm.bannerUrl,
      title: _vm.bannerTitle,
      description: _vm.bannerText
    }
  })], 1), _c("Function", {
    attrs: {
      title: "产品功能",
      adslist: _vm.adsList,
      itemcls: true
    }
  }), _c("section", {
    staticClass: "ftr_applications"
  }, [_c("div", {
    staticClass: "ftr_applications_main"
  }, [_c("Title", {
    staticClass: "title",
    attrs: {
      title: "产品应用"
    }
  }), _vm._m(0)], 1)]), _c("section", {
    staticClass: "advantages"
  }, [_c("div", {
    staticClass: "advantages-main"
  }, [_c("Title", {
    staticClass: "title",
    attrs: {
      title: "产品优势"
    }
  }), _c("Advantages2", {
    attrs: {
      leftItems: _vm.adsListLeft,
      rightItems: _vm.adsListRight
    }
  })], 1)]), _c("Appointment2")], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("ul", {
    staticClass: "list"
  }, [_c("li", [_c("img", {
    staticClass: "icon-strengths",
    attrs: {
      src: require("@/assets/images/ftr-app-1.png"),
      alt: "strengths"
    }
  }), _c("h4", [_vm._v("基础文本审核")]), _c("p", [_vm._v("智能识别文本中存在的内容错误、格式错误和语义错误等主要基础文本错误类型并进行标记校正")]), _c("div", {
    staticClass: "line"
  })]), _c("li", [_c("img", {
    staticClass: "icon-strengths",
    attrs: {
      src: require("@/assets/images/ftr-app-2.png"),
      alt: "strengths"
    }
  }), _c("h4", [_vm._v("财务数据审核")]), _c("p", [_vm._v("智能识别文本中的财务数据，并对数据的正确性、合规性、真实性，进行全面、合理的审核")]), _c("div", {
    staticClass: "line"
  })])]);
}];
render._withStripped = true;
export { render, staticRenderFns };